import {
  ContractType,
  PermissionUserType,
  Maybe
} from "@store/graphql/helpers/types.graphql";
import { useAtom, atom } from "@libraries/jotai";

export interface ContractPermissions
  extends Omit<ContractType, "permissionsUsers"> {
  permissions: Maybe<PermissionUserType>[] | undefined;
  userId: string;
}

const permissionsUsersAtom = atom<ContractPermissions[]>([]);
const filteredPermissionsUsersAtom = atom<ContractPermissions[]>([]);

export default function usePermissionsUsers() {
  const [value, setValue] = useAtom(permissionsUsersAtom);
  const [filteredPermissionsUsers, setFilteredPermissionsUsers] = useAtom(
    filteredPermissionsUsersAtom
  );

  return {
    value,
    setValue,
    filteredPermissionsUsers,
    setFilteredPermissionsUsers
  };
}
